import {ShowCategories} from './show-categories';

export default ShowCategories;
